import { render, staticRenderFns } from "./Convocacao.vue?vue&type=template&id=0785ae78"
import script from "./Convocacao.vue?vue&type=script&lang=js"
export * from "./Convocacao.vue?vue&type=script&lang=js"
import style0 from "./Convocacao.vue?vue&type=style&index=0&id=0785ae78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports